module.exports = __webpack_public_path__ + "407d060f8a46c4a8390a33b09152511c.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/test-step-5.svg
// module id = 489
// module chunks = 0